export default "__VITE_ASSET__3772676e__"